function buildRing({ containerId, radius, itemSize, itemCount, arrowIndices = [] }) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const diameter = radius * 2;
    container.style.width = diameter + 'px';
    container.style.height = diameter + 'px';

    const arrowSet = new Set(arrowIndices);

    for (let i = 0; i < itemCount; i++) {
        const angle = (360 / itemCount) * i;
        const rad = (angle * Math.PI) / 180;

        const pointX = radius + radius * Math.cos(rad);
        const pointY = radius + radius * Math.sin(rad);

        const isArrow = arrowSet.has(i);

        const el = document.createElement('div');

        el.style.cssText = `
            position: absolute;
            left: ${pointX - itemSize / 2}px;
            top: ${pointY - itemSize / 2}px;
            width: ${itemSize}px;
            height: ${itemSize}px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: visible;
            transform: rotate(${angle}deg);
        `;

        if (isArrow) {
            el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"
                style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(90deg);flex-shrink:0;">
                <path d="M10.4282 12.062L15.8923 13.5261L14.4282 18.9902" stroke="#E93635" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;
        } else {
            el.style.background = '#808FA3';
        }

        container.appendChild(el);
    }
}

if (document.querySelector('.GlobeAnimation')) {
    buildRing({
        containerId: 'ringInner',
        radius: 130,
        itemSize: 2,
        itemCount: 36,
    });

    buildRing({
        containerId: 'ringOuter',
        radius: 185,
        itemSize: 2,
        itemCount: 48,
        arrowIndices: [0, 6, 12, 18, 24, 30, 36, 42]
    });
}